module.exports = __webpack_public_path__ + "img/right-arrow.2b3c0985.svg";